import React from 'react';
import type { BenefitsSimilarDealsProps } from './interfaces';
import styles from './BenefitsSimilarDeals.module.scss';
import clsx from 'clsx';
import Button from '../Button/Button';
import { ClickableAction } from '../Clickable/consts';
import { ButtonColor } from '../Button/consts';

const BenefitsSimilarDeals = ({
  title,
  children,
}: BenefitsSimilarDealsProps) => {
  return (
    <div className={styles.base}>
      <h3 className={styles.headline}>{title}</h3>
      <div className={styles.wrapper} tabIndex={0}>
        {children &&
          React.Children.map(children, (child) => (
            <div className={styles.item}>{child}</div>
          ))}
        <div className={clsx(styles.item, styles.overviewLink)}>
          <span className={styles.overviewLinkText}>
            Entdecken Sie jetzt alle Vorteile!
          </span>
          <Button
            actionType={ClickableAction.Linkintern}
            linkintern="/vorteile/plus"
            color={ButtonColor.Secondary}
            className={styles.overviewLinkButton}
          >
            Zurück zur Übersicht
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BenefitsSimilarDeals;
